import { useEffect, useState } from 'react';
import { Experience, useExperienceApi } from '@/webapi/use-experience-api';

type ProductsForReport = Experience[`listOfProductsForReport`];

function stableStringify(value: unknown): string {
  return JSON.stringify(value, (_key, val) => {
    if (val && typeof val === `object` && !Array.isArray(val)) {
      return Object.keys(val)
        .sort()
        .reduce((sorted, k) => {
          sorted[k] = val[k];
          return sorted;
        }, {} as Record<string, unknown>);
    }
    return val;
  });
}

export function hasProductsForReportChanged(
  currentExperience: Experience,
  publishedList: ProductsForReport | null | undefined,
): boolean {
  return (
    stableStringify(currentExperience.listOfProductsForReport ?? null) !==
    stableStringify(publishedList ?? null)
  );
}

export function useServerPublishedProductsForReport(
  experienceId: string | undefined,
  enabled: boolean,
): ProductsForReport | null | undefined {
  const { getExperience } = useExperienceApi();
  const [value, setValue] = useState<ProductsForReport | null | undefined>(
    undefined,
  );

  useEffect(() => {
    if (!experienceId || !enabled) return;
    getExperience(experienceId)
      .then(({ experience }) => {
        setValue(experience?.listOfProductsForReport ?? null);
      })
      .catch(() => setValue(null));
  }, [experienceId]);

  return value;
}
